export default class Version {
  // Parses a raw VERSION command response — accepts either the new JSON format
  // {"firmware":"0.4.10","schema_version":4,"device":"midulate"} or the legacy
  // plain string "MIDULATE 0.4.10".  Returns the version string (e.g. "0.4.10")
  // or null if the response is unrecognised.
  static parseVersionResponse(response) {
    try {
      const parsed = JSON.parse(response);
      if (parsed && typeof parsed.firmware === 'string') {
        return parsed.firmware;
      }
    } catch {
      // not JSON — fall through to legacy format
    }
    const match = response && response.match(/MIDULATE (\d+\.\d+\.\d+)/);
    return match ? match[1] : null;
  }

  static parse(versionString) {
    const parts = versionString.split('.').map(part => parseInt(part, 10));
    return new Version(parts[0], parts[1], parts[2]);
  }

  constructor(major, minor, patch) {
    this.major = major;
    this.minor = minor;
    this.patch = patch;
  }

  compatibleWith(otherVersion) {
    return (this.major === otherVersion.major && this.minor === otherVersion.minor);
  }

  isOlderThan(otherVersion) {
    if (this.major !== otherVersion.major) return this.major < otherVersion.major;
    if (this.minor !== otherVersion.minor) return this.minor < otherVersion.minor;
    return this.patch < otherVersion.patch;
  }

  toString() {
    return `${this.major}.${this.minor}.${this.patch}`;
  }
}
